<template>
  <div class="component-box">

    <VueperSlides
      autoplay
      fade
      class="main-slideshow"
      @slide="$refs.vueperslides2.goToSlide($event.currentSlide.index, { emit: false })"
      ref="vueperslides1"
      :bullets="false"
      :slideRatio="1/2">
      <VueperSlide
        v-for="(slideImage) in slideshowImages"
        :key="slideImage.id"
        
        :title="slideImage.title">
        <template #content>
          <div class="slider-content">
            <c-img :imgId="slideImage.id" childclass="main-slider-img" />
            <div class="image-title">{{slideImage.title}}</div>
          </div>
        </template>
      </VueperSlide>
    </VueperSlides> 

    <div class="thumbnail-slideshow">
      <VueperSlides
        class="no-shadow thumbnails"
        ref="vueperslides2"
        @slide="$refs.vueperslides1.goToSlide($event.currentSlide.index, { emit: false })"
        :visible-slides="thumbnailCount"
        fixed-height="100px"
        :bullets="false"
        :touchable="false"
        :gap="2.5"
        :arrows="false">
        <VueperSlide
          v-for="(slideImage, i) in slideshowImages"
          :key="slideImage.id"
          class="thumbnail"
          @click.native="$refs.vueperslides2.goToSlide(i)">
          <template #content>
            <div class="thumbnail-slider-content">
              <c-img :imgId="slideImage.id" childclass="thumbnail-slider-img" />
            </div>
          </template>
        </VueperSlide>
      </VueperSlides>
    </div>
  </div>
  
</template>

<style scoped>
  @import '../../assets/styles/global-styles.css';
  @import '../../assets/styles/variables.css';

  @media only screen and (min-width: 901px) {
    .component-box {
      padding-left: 40px;
      padding-right: 40px;
    }
  }
  

  .main-slideshow {
    margin-bottom: 25px;
  }

  .slider-content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    position: relative;
  }

  .image-title {
    color: white;
    text-align: center;
    position: absolute;
    bottom: 0;
    text-shadow: 1px 1px 3px rgba(8, 8, 14, 0.637);
    padding: 10px;
    width: 100%;
    transition: 0.3s;
    font-size: 1.15em;
  }

  @media only screen and (max-width: 900px) {
    .image-title {
      font-size: 0.9em;
    }
  }

  .slider-content:hover .image-title {
    background: rgba(8, 8, 14, 0.644);
  }


  .thumbnail {
    cursor: pointer;
    transition: 0.3s;
  }

  .thumbnail:hover {
    opacity: 0.75;
  }

  .thumbnail-slider-content {
    box-shadow: 0 0 5px #252a57;
  }

  .main-slideshow >>> .vueperslides__parallax-wrapper {
    border-radius: 20px;
  }


</style>

<style>

  .main-slider-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
		object-position: center;

    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -o-user-select: none;
    user-select: none;

    -webkit-user-drag: none; 
    -khtml-user-drag: none; 
    -moz-user-drag: none; 
    -o-user-drag: none; 
  }

  .thumbnail-slider-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
		object-position: center;
  }

  .vueperslides--fixed-height.vueperslides--bullets-outside {
    margin-bottom: calc(60px * var(--margin-factor) * var(--margin-factor)) !important;
  }
</style>

<script lang="ts">
  import { Component, Vue } from 'vue-property-decorator';
  import axios from 'axios';
  import { AuthenticationService } from '../../services/authentication.service';
  import { SlideshowImage } from '@/interfaces/SlideshowImage';
  import * as UrlConsts from '@/scripts/UrlConsts';
  import CustomImage from '../CustomImage.component.vue';

  import { VueperSlides, VueperSlide } from 'vueperslides'
  import 'vueperslides/dist/vueperslides.css'

  /**
   * @desc composant affichant les images du diaporama
   */
  @Component({
    components: {
      'c-img': CustomImage,
      VueperSlides,
      VueperSlide,
    },
  })
  export default class HomeSlideshow extends Vue {
    
    slideshowImages : Array<SlideshowImage> = []
    thumbnailCount = 5;
    
    mounted(): void {
      if((this as any).$mq === 'mobile' || (this as any).$mq === 'tablet') 
        this.thumbnailCount = 3;
      this.loadData();
    }

    /**
     * @desc charge les images du diaporama
     */
    private loadData() : void {
      const headers = AuthenticationService.getRequestHeader();

      axios
        .get(UrlConsts.getAllSlideshowImgs, headers)
        .then((response) => {
          this.slideshowImages = response.data
            .sort((a : any, b : any) => a.order- b.order)
            .map((x: any) => 
              {
                return {
                  title: x.title,
                  content: `
                    <c-img imgId="${x.id}" />
                  `,
                  id: x.id
                };
              }
            );
        })
        .catch(error => console.log(error))
    }
  }
</script>
